<template>

  <!--::footer::-->
  <footer class="footer_part">
    <div class="container">
      <div class="row">
        <div class="col-sm-6 col-lg-3">
          <div v-if="textoRodape != ''" class="single_footer_part">
            <h4>Sobre</h4>
            <p v-html="textoRodape[0].itiResumo1"></p>
            <router-link to="/" class="footer_logo"><img :src="$imagens + 'logo-footer.png'" alt=""></router-link>

          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="single_footer_part">
            <h4>Menu</h4>
            <ul class="list-unstyled">
              <li><router-link to="/">Página Inicial</router-link></li>
              <li><router-link to="/sobre">Sobre a Nossa Empresa</router-link></li>
              <li><router-link to="/blog">Nossas Notícias</router-link></li>
              <li><router-link to="/contato">Entre em Contato</router-link></li>
            </ul>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="single_footer_part">
            <h4>Produtos</h4>
            <ul class="list-unstyled">
              <li v-for="menu in listaProdutos" :key="menu.itiId">
                <router-link :to="'/ProdutosDetalhe/' + menu.itiId + '/' + formataLink(menu.itiNome)">
                  {{ menu.itiNome }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="single_footer_part">
            <h4>Informações Gerais</h4>
            <ul class="list-unstyled">
              <li v-for="lgpd in informacoes" :key="lgpd.itiId">
                <router-link
                  :to="'/informacoes/' + lgpd.itiId + '/' + lgpd.itiNome.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')">
                  {{ lgpd.itiNome }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-6 col-sm-6 col-lg-6">
          <div class="copyright_text">
            <a href="https://avancedigital.com.br" target="_blank"><img :src="$imagens + 'avance-digital.png'"></a>
          </div>
        </div>
        <div class="col-6 col-sm-6 col-lg-6">
          <div class="footer_icon">
            <ul v-if="redesSociais && redesSociais.length > 0" class="list-unstyled">

              <li v-if="redesSociais[0].itiCampoExtra1 !== '0'">
                <a :href="redesSociais[0].itiCampoExtra1" target="_blank">
                  <i class="fa fa-facebook-f"></i>
                </a>
              </li>

              <li v-if="redesSociais[0].itiCampoExtra2 !== '0'">
                <a :href="redesSociais[0].itiCampoExtra2" target="_blank">
                  <i class="fa fa-linkedin"></i>
                </a>
              </li>

              <li v-if="redesSociais[0].itiNome !== '0'">
                <a :href="redesSociais[0].itiNome" target="_blank">
                  <i class="fa fa-youtube"></i>
                </a>
              </li>
              <li v-if="redesSociais[0].itiReferencia !== '0'">
                <a :href="redesSociais[0].itiReferencia" target="_blank">
                  <i class="fa fa-instagram"></i>
                </a>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageFooter',
  components: {

  },

  data: () => ({
    textoRodape: [],
    listaProdutos: [],
    redesSociais: [],
    informacoes: [],

  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

  },

  created() {

    // RODAPÉ  
    axios.get('/Process/InsInstitucional/institucional/10/dadosrodape/0/x')
      .then(response => {
        this.textoRodape = response.data;
        //console.log('textoRodape')
        //console.log(this.textoRodape)
      })
      .catch(error => {
        console.error(error);
      });

    // PRODUTOS
    axios.get('/Process/InsInstitucional/institucional/46/listadeprodutos/0/x')
      .then(response => {
        this.listaProdutos = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const valorA = parseInt(a.itiOrdem) || 0;
          const valorB = parseInt(b.itiOrdem) || 0;
          return valorA - valorB;
        });
        //console.log('listaProdutos')
        //console.log(this.listaProdutos)
      })
      .catch(error => {
        console.error(error);
      });

    // REDES SOCIAIS
    axios.get('/Process/InsInstitucional/institucional/55/redessociais/0/x')
      .then(response => {
        this.redesSociais = response.data;
        console.log('Dados recebidos:', this.redesSociais);
      })
      .catch(error => {
        console.error(error);
      });

    // INFORMAÇÕES GERAIS
    axios.get('/Process/InsInstitucional/institucional/54/listadasinformacoes/0/x')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        //console.log('informacoes')
        //console.log(this.informacoes)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>